export default __webpack_public_path__ + "f964c67c6335de11b145b96e608960ee.svg";